export const inputReason = {
  width: '100%',
}

export const innerFormGroup = {
  marginLeft: 0,
}

export const outerFormGroup = {
  /*float: 'right',
  marginRight: 0*/
}
